<script lang="ts">
	import SessionExpired from '$lib/components/model/SessionExpired.svelte';
	import NavigationBar from '$lib/components/navigation/NavigationBar.svelte';
	import ProfileDetails from '$lib/components/profile/ProfileDetails.svelte';
</script>

<svelte:head>
	<title>My Dashboard</title>
</svelte:head>

<SessionExpired protectedPage />
<section class="flex flex-col justify-start grow items-stretch mb-40">
	<div class="flex flex-col flex-grow items-center justify-center p-4 lg:p-0">
		<div class="flex flex-col w-full lg:max-w-[1284px] xl:min-w-[1284px] gap-6 mt-20">
			<ProfileDetails />
			<NavigationBar />
			<slot />
		</div>
	</div>
</section>

<style>
</style>
